// extracted by mini-css-extract-plugin
module.exports = {"container":"LogisticsScreen_container__2rVYz"};